import React from 'react';
import { TriggersTooltips } from '../../TriggersTooltip';
import makeStyles from '@material-ui/styles/makeStyles';
import { ReactComponent as InfoIcon } from '../../../assets/images/icon-info-circle.svg';
import useFormatCurrency from '../../../localisation/useCurrency';

const useStyles = makeStyles({
    root: {
        padding: '0.75rem',
    },
    icon: {
        width: '2.1875rem',
        height: '2.1875rem',
    },
    label: {
        padding: '1.125rem 0 0.375rem',
        fontSize: '0.9rem',
        display: 'flex',
        '& >div': {
            marginLeft: '0.3125rem',
            cursor: 'pointer',
        },
    },
    value: {
        fontSize: '1.3rem',
        fontWeight: 600,
    },
});

export interface ITotalItem {
    label: string;
    value: number;
    icon: React.ReactNode;
    tooltipTxt: string;
    isCurrency: boolean;
}

const TotalItem = (props: ITotalItem) => {
    const classes = useStyles();
    const { formatCurrency } = useFormatCurrency();
    return (
        <div className={classes.root} data-component-name={`TOTAL_ITEM_${props.label.split(' ')[1].toUpperCase()}`}>
            <div className={classes.icon}>{props.icon}</div>
            <div className={classes.label}>
                {props.label}
                <TriggersTooltips title={props.tooltipTxt} disabled={true} placement="top">
                    <InfoIcon />
                </TriggersTooltips>
            </div>
            <div className={classes.value}>{props.isCurrency ? formatCurrency(props.value) : props.value}</div>
        </div>
    );
};

export default TotalItem;
